import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const rows = [{
  bad: 'Vitaminas básicas sin sinergia',
  good: 'Fórmula de 8 activos diseñada en conjunto'
}, {
  bad: 'Formuladas para "todas"',
  good: 'Exclusivamente para mujeres maduras'
}, {
  bad: 'Sin foco hormonal',
  good: 'Ataca directamente el cortisol y la insulina'
}, {
  bad: 'Sabor artificial y textura gomosa plástica',
  good: 'Sabor frutos del bosque, textura suave natural'
}, {
  bad: 'Resultados genéricos',
  good: 'Protocolo de transformación en 21 días'
}];
export function Diferenciacion() {
  return <section className="bg-esbelta-violet py-16 md:py-24 px-4 text-white" data-id="element-27">
      <div className="max-w-4xl mx-auto" data-id="element-28">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-29">
          ¿Por qué ESBELTA® y no cualquier otra gomita?
        </h2>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl border border-white/20 overflow-hidden" data-id="element-30">
          <div className="grid grid-cols-2 bg-white/5 border-b border-white/10" data-id="element-31">
            <div className="p-4 md:p-6 text-center font-bold text-white/60 text-sm md:text-base" data-id="element-32">
              ❌ Las otras gomitas
            </div>
            <div className="p-4 md:p-6 text-center font-bold text-white text-sm md:text-base bg-white/10" data-id="element-33">
              ✅ ESBELTA®
            </div>
          </div>

          <div className="divide-y divide-white/10" data-id="element-34">
            {rows.map((row, idx) => <div key={idx} className="grid grid-cols-2" data-id="element-35">
                <div className="p-4 md:p-6 flex items-center justify-center text-center text-white/70 text-sm md:text-base" data-id="element-36">
                  {row.bad}
                </div>
                <div className="p-4 md:p-6 flex items-center justify-center text-center font-medium text-white text-sm md:text-base bg-white/5" data-id="element-37">
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}